import { normalQueryTypes } from '@ow/utils'

const filterSpec = {
  queryTypes: ['equal', 'inList'].map((p) => normalQueryTypes[p]),
}

export { filterSpec }
